import { render } from "./NotificationsHub.vue?vue&type=template&id=fa564ec8&scoped=true"
import script from "./NotificationsHub.vue?vue&type=script&lang=js"
export * from "./NotificationsHub.vue?vue&type=script&lang=js"

import "./NotificationsHub.vue?vue&type=style&index=0&id=fa564ec8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa564ec8"]])

export default __exports__